import ChevronUpIcon from '@/components/Icon/ChevronUpIcon'
import type { Property } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import { getPath } from '@/utils/next-util'
import { Disclosure } from '@headlessui/react'
import { useMemo, useState } from 'react'
import useCategorySortFilter from '../useCategorySortFilter'

const minimalItems = 4

interface CategoryProductFilterItemProps {
  filter: Property
  defaultOpen?: boolean
}

const CategoryProductFilterItem = ({
  filter,
  defaultOpen,
}: CategoryProductFilterItemProps) => {
  const { handleChangeFilter, isFilterActive } = useCategorySortFilter()
  const canShowMore = filter.values?.length > minimalItems
  const [showMore, setShowMore] = useState(canShowMore)

  const renderFilterValues = useMemo(
    () => (showMore ? filter.values?.slice(0, minimalItems) : filter.values),
    [filter.values, showMore]
  )

  return (
    <div className='px-3'>
      <Disclosure defaultOpen={defaultOpen}>
        {({ open }) => (
          <>
            <Disclosure.Button className='flex w-full cursor-pointer items-center justify-between'>
              <span className='text-sm font-semibold text-[#010103]'>
                {getTranslate(filter.name)}
              </span>
              <ChevronUpIcon
                className={`${!open ? 'rotate-180 transform' : ''} h-2 w-3`}
              />
            </Disclosure.Button>
            <Disclosure.Panel className='mt-3 flex flex-col gap-2'>
              {renderFilterValues.map(item => (
                <div
                  className='form-check-default small form-check-shipping box-checkbox'
                  key={item._id}
                >
                  <input
                    className='form-checkbox-input'
                    id={item._id}
                    name={item._id}
                    type='checkbox'
                    defaultChecked={isFilterActive(
                      getPath(filter.slugs),
                      getTranslate(item.value)
                    )}
                    onChange={() =>
                      handleChangeFilter(
                        getPath(filter.slugs),
                        getTranslate(item.value)
                      )
                    }
                  />
                  <label
                    className='form-checkbox-label flex flex-col'
                    htmlFor={item._id}
                  >
                    {getTranslate(item.value)}
                  </label>
                </div>
              ))}
              {canShowMore && (
                <button
                  className='mt-2 flex w-fit items-center gap-1 text-xs text-primary'
                  onClick={() => setShowMore(!showMore)}
                >
                  {!showMore ? 'Hiển thị ít hơn' : 'Hiển thị nhiểu hơn'}
                  <ChevronUpIcon
                    className={`h-2 w-2 fill-primary ${
                      showMore && 'rotate-180 transform'
                    }`}
                  />
                </button>
              )}
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
    </div>
  )
}

export default CategoryProductFilterItem
